import { diaInicialDepoisDoFinal } from './utilitarios';

export interface Periodo<T> {
    dataInicio: T;
    dataFim: T;
}

// Qualquer data pode ser escolhida em qualquer ponta do período: quando a escolha inverte o
// intervalo, a outra ponta é arrastada para o mesmo dia em vez de o calendário bloquear dias.
export const ajustarPeriodoPorNovaDataInicial = (novaInicial: Date | null, dataFim: Date | null): Periodo<Date | null> => ({
    dataInicio: novaInicial,
    dataFim: novaInicial && dataFim && diaInicialDepoisDoFinal(novaInicial, dataFim) ? novaInicial : dataFim,
});

export const ajustarPeriodoPorNovaDataFinal = (dataInicio: Date | null, novaFinal: Date | null): Periodo<Date | null> => ({
    dataInicio: novaFinal && dataInicio && diaInicialDepoisDoFinal(dataInicio, novaFinal) ? novaFinal : dataInicio,
    dataFim: novaFinal,
});

export const ajustarPeriodoIsoPorNovaDataInicial = (novaInicial: string, dataFim: string): Periodo<string> => ({
    dataInicio: novaInicial,
    dataFim: novaInicial && dataFim && novaInicial > dataFim ? novaInicial : dataFim,
});

export const ajustarPeriodoIsoPorNovaDataFinal = (dataInicio: string, novaFinal: string): Periodo<string> => ({
    dataInicio: novaFinal && dataInicio && dataInicio > novaFinal ? novaFinal : dataInicio,
    dataFim: novaFinal,
});
